import { Component, OnInit } from '@angular/core';
import { RouterService } from '../../../core/services/router.service';
import { UserService } from '../../../core/services/user.service';
import { TranslateModule } from '@ngx-translate/core';
import { UiFacade } from '../../../../store/facade/ui.facade';
import { MessageBoxComponent } from '../message-box/message-box.component';

import { ButtonComponent } from '../buttons/button/button.component';

@Component({
    selector: 'je-critical-error',
    templateUrl: './critical-error.component.html',
    imports: [ButtonComponent, TranslateModule, MessageBoxComponent],
})
export class CriticalErrorComponent implements OnInit {
    public remainingTime: number = 30;
    public errorTranslateKey: string;
    private interval: any;

    constructor(
        private userService: UserService,
        private routerService: RouterService,
        private uiFacade: UiFacade,
    ) {}

    ngOnInit(): void {
        this.uiFacade.key$.subscribe(key => {
            this.errorTranslateKey = key;
        });
        this.startCountdown();
    }

    public onLogout(): void {
        this.userService.logout();
        this.routerService.navigateToLogin();
        window.location.reload();
    }

    startCountdown(): void {
        this.interval = setInterval(() => {
            this.remainingTime--;
            if (this.remainingTime <= 0) {
                clearInterval(this.interval);
                this.onLogout();
            }
        }, 1000);
    }
}
